import Req from "../interceptors/token-interceptor";

const ConfigChoiceCategoryService = (function () {
  function _getAllConfigChoiceCategory() {
    return Req.get(`/api/config-choices/categories`);
    // return Req.get(`/api/configChoiceCategories/list`);
  }
  function _getConfigChoiceCategory(id) {
    return Req.get(`/api/config-choices/categories/${id}`);
  }
  function _addConfigChoiceCategory(data) {
    return Req.post("/api/config-choices/categories", data);
  }
  function _editConfigChoiceCategory(data, id) {
    return Req.put(`/api/config-choices/categories/${id}`, data);
  }
  function _deleteConfigChoiceCategory(id) {
    return Req.delete(`/api/config-choices/categories/${id}`);
  }
  function _deleteMultipleConfigChoiceCategory(ids) {
    return Req.post("/api/config-choices/categories/delete", { ids: ids });
  }
  return {
    getAllConfigChoiceCategory: _getAllConfigChoiceCategory,
    getConfigChoiceCategory: _getConfigChoiceCategory,
    addConfigChoiceCategory: _addConfigChoiceCategory,
    editConfigChoiceCategory: _editConfigChoiceCategory,
    deleteConfigChoiceCategory: _deleteConfigChoiceCategory,
    deleteMultipleConfigChoiceCategory: _deleteMultipleConfigChoiceCategory,
  };
})();
export default ConfigChoiceCategoryService;
